import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import eng from "./translations/en/en.json";
import fr from "./translations/fr/fr.json";
import nl from "./translations/nl/nl.json";
import de from "./translations/de/de.json";

export const LANGUAGES = ["eng","fr", "nl","de"];

i18n
.use(LanguageDetector)
.use(initReactI18next)
.init({
  ns: ["translation"],
  defaultNS: "translation",
  fallbackLng:  "fr",
  resources: {
    eng,
    fr,
    nl,
    de
  },
  whitelist: ["dev", ...LANGUAGES],

});

export default i18n;
